var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartRecoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7131 6.40005C19.1277 7.84305 20 9.81969 20 12.0001C20 14.2063 19.1069 16.204 17.6625 17.6512M6.4 17.7132C4.91891 16.2613 4 14.238 4 12.0001C4 9.78802 4.89777 7.78569 6.34882 6.33752",
    stroke: "#1A1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4279 8.83523C16.2766 9.64706 16.8 10.7591 16.8 11.9858C16.8 13.2271 16.2641 14.3509 15.3975 15.1652M8.64 15.2C7.75135 14.3832 7.2 13.2449 7.2 11.9858C7.2 10.7413 7.73866 9.61479 8.60929 8.80005",
    stroke: "#1A1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3251 10.7609C14.0417 11.287 14.4 11.55 14.4 12C14.4 12.4499 14.0417 12.713 13.3251 13.2391C13.1272 13.3843 12.931 13.5211 12.7507 13.635C12.5926 13.735 12.4134 13.8384 12.228 13.9399C11.513 14.3312 11.1556 14.5268 10.8349 14.3102C10.5143 14.0936 10.4852 13.6402 10.4269 12.7333C10.4104 12.4768 10.4 12.2254 10.4 12C10.4 11.7746 10.4104 11.5232 10.4269 11.2667C10.4852 10.3598 10.5143 9.90634 10.8349 9.68974C11.1556 9.47313 11.513 9.66877 12.228 10.0601C12.4134 10.1616 12.5926 10.265 12.7507 10.3649C12.931 10.4789 13.1272 10.6156 13.3251 10.7609Z",
    stroke: "#1A1B1B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRecoring);
export default __webpack_public_path__ + "static/media/start-recoring.9ea095a479abd77682520dc4475b2f14.svg";
export { ForwardRef as ReactComponent };